<div class="flex justify-center">
	<section class="flex flex-col justify-center w-full gap-8 p-2 xl:flex-row xl:p-8">
		<div class="flex flex-col w-full gap-2 md:gap-8 max-w-7xl">
			<slot />
		</div>
	</section>
</div>
